<template>
  <div class="card-bind-body">
    <div class="card-bind-con">
      <div class="card-bind-nav">
        <navbar title="油卡绑定" :lefticonshow="true" :lefticonwidth="9" :lefticonheight='16' titlecolor="#fff" :lefticon="newoilcardwhitebackicon" @goback="goBack"></navbar>
      </div>
      <div class="card-bind-second-div">
        <div class="card-bind-tag-div">
          <div class="card-bind-tag-item" :class="{'card-bind-tag-item-activate':operator=='sinopec'}" @click="changeTagIndex('sinopec')">
            <div><img :src="chinasinopecbindlogo" alt=""><span>中国石化</span></div>
          </div>
          <div class="card-bind-tag-item" :class="{'card-bind-tag-item-activate':operator=='cnpc'}" @click="changeTagIndex('cnpc')">
            <div><img :src="chinapetroleumbindlogo" alt=""><span>中国石油</span></div>
          </div>
        </div>
        <div class="card-bind-input-div">
          <commoninput :value.sync="gasCardNo" color="#333333" type="number" :maxLength="operator=='sinopec' ? 19 : 16" :fontWeight="500" :placeholder="card_placeholder" fontSize="24px" :clearshow="true" />
        </div>
        <div class="card-bind-input-div">
          <commoninput :value.sync="name" color="#333333" :fontWeight="500" placeholder="请输入卡号的真实姓名" fontSize="24px" :clearshow="true" />
        </div>
        <div class="card-bind-input-div">
          <commoninput :value.sync="id_card_number" color="#333333" :maxLength="18" :fontWeight="500" placeholder="请输入卡号的证件号码" fontSize="24px" :clearshow="true" />
        </div>
        <div class="card-bind-tips">暂不支持副卡及字母开头的加油卡充值</div>
        <div class="card-bind-btn" @click="bindCard"><span>确认绑定</span></div>
      </div>
      <div class="card-bind-third-div">
        <div>充值说明</div>
        <div>
          <p v-for="(item,index) in recharge_descriptions" :key="index">{{item}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import navbar from '../components/nav-bar.vue'
  import commoninput from '../components/common-input.vue'
  import { bindThirdrechargeOilCard, getThirdrechargeOilChargeDescription } from '../api/index'
  import { Toast } from 'vant'
  export default {
    components: { navbar, commoninput },
    data() {
      return {
        newoilcardwhitebackicon: require('@/assets/recharge/new-oilcard-white-back-icon.png'),
        chinapetroleumbindlogo: require('@/assets/recharge/china-petroleum-bind-logo.png'),
        chinasinopecbindlogo: require('@/assets/recharge/china-sinopec-bind-logo.png'),
        operator: 'sinopec',
        more_control_show: false,
        untiePupShow: false,
        card_placeholder: "请输入中国石化卡号",
        gasCardNo: '',
        bind_loading: false,
        recharge_descriptions:'',
        name:'',
        id_card_number:''
      }
    },
    created() {
      getThirdrechargeOilChargeDescription({ "charge_id": "14", "channel_id": "8" }).then((res) => {
        for (let item of res.data) {
          if (item.title == "油卡充值说明") {
            this.recharge_descriptions = item.description.split("\n").map((item, i) => `${item}`);
          }
        }
      })
    },
    methods: {
      changeTagIndex(index) {
        this.operator = index
        if (index == 'sinopec') {
          this.card_placeholder = "请输入中国石化卡号"
        } else {
          this.card_placeholder = "请输入中国石油卡号"
        }
        this.gasCardNo = ''
      },
      bindCard() {
        if (this.bind_loading) return
        if (this.operator == 'sinopec' && (this.gasCardNo.length != 19 || this.gasCardNo[0] != 1)) {
          return Toast('请输入正确的19位中石化卡号')
        } else if (this.operator == 'cnpc' && (this.gasCardNo.length != 16 || (this.gasCardNo[0] != 9 && this.gasCardNo.slice(0,2) != '70'))) {
          return Toast('请输入正确的16位中石油卡号')
        }
        this.bind_loading = true
        bindThirdrechargeOilCard({ gasCardNo: this.gasCardNo, operator: this.operator,id_card_number:this.id_card_number,name:this.name }).then((res) => {
          if (res.status == 1) {
            this.gasCardNo = ''
            Toast('添加成功')
            if (this.$route.query.from == 'recharge_home') {
              this.$router.replace('/new-oli/recharge?from=card_bind')
            } else {
              this.$router.go(-1)
            }

          }
        }).catch((err) => {
          const keys = Object.keys(err)
          Toast(err[keys[0]][0])
          this.bind_loading = false
        })
      },
      goPage(path) {
        this.$router.push({
          path
        })
      },
      goBack() {
        if (this.$route.query.back_to == 'rechargeHome') {
          this.$router.replace('/recharge/rechargeHome')
        } else {
          this.$router.go(-1)
        }

      }
    }
  }
</script>
<style lang="less">
  .card-bind-body {
    .card-bind-input-div {
      margin: 30px 14px 0;
      padding-bottom: 2px;
      border-bottom: 1px solid #EBEBEB;

      .common-input {
        .input-div {
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          height: 33px;
          padding-left: 4px;

          &::-webkit-input-placeholder {
            /* placeholder颜色 */
            color: #aab2bd;
            /* placeholder字体大小 */
            font-size: 17px;
            line-height: normal;
            /* for non-ie */
            line-height: 21px;
            /* for ie */
          }
        }
      }
    }
  }
</style>
<style lang="less" scoped>
  .card-bind-body {
    min-height: 100vh;
    background: rgba(0, 0, 0, 0.03);

    .card-bind-con {
      padding-top: 88px;
      background: linear-gradient(180deg, #fa730a 2%, #f31839 70%, rgba(243, 24, 57, 0.00));
      background-size: 100% 299px;
      background-repeat: no-repeat;

      .card-bind-nav {
        padding-top: 44px;
        position: fixed;
        top: 0;
        left: 0;

        .oil-card-tag-div {
          height: 44px;
          display: flex;

          .oil-tag-item {
            flex: 1;
            font-size: 14px;
            font-weight: 400;
            text-align: left;
            color: #333333;
            line-height: 44px;
            text-align: center;
          }

          .oil-tag-actiave {
            color: #F9720E;
            position: relative;

            &::after {
              content: '';
              width: 84px;
              height: 4px;
              background: linear-gradient(135deg, #f9750d, #f44e19);
              border-radius: 2px;
              position: absolute;
              left: 50%;
              bottom: 0;
              transform: translateX(-50%);
            }
          }
        }
      }

      .card-bind-second-div {
        margin: 12px 12px 0;
        background: #ffffff;
        border-radius: 8px;
        padding-bottom: 89px;
        overflow: hidden;

        .card-bind-tag-div {
          display: flex;
          background-color: #feeae8;


          .card-bind-tag-item {
            flex: 1;
            background: #feeae8;
            text-align: center;
            padding: 12px 0;


            &:nth-child(1) {
              border-radius: 8px 8px 8px 0px;
              position: relative;

              &::before {
                content: '';
                position: absolute;
                right: 0px;
                bottom: 0;
                width: 12px;
                height: 12px;
                background-color: #fff;
              }

              &::after {
                content: '';
                position: absolute;
                right: 0;
                bottom: 0;
                width: 12px;
                height: 12px;
                background-color: #feeae8;
                border-radius: 0 0 8px 0;
              }
            }

            &:nth-child(2) {
              border-radius: 8px 0 8px 0px;
              position: relative;

              &::before {
                content: '';
                position: absolute;
                left: -4px;
                bottom: 0;
                width: 12px;
                height: 12px;
                background-color: #fff;
              }

              &::after {
                content: '';
                position: absolute;
                left: 0;
                bottom: 0;
                width: 12px;
                height: 12px;
                background-color: #feeae8;
                border-radius: 0 0 0 8px;
              }
            }

            div {
              margin: auto;
            }

            img {
              width: 20px;
              height: 20px;
            }

            span {
              display: inline-block;
              font-size: 14px;
              font-weight: 500;
              text-align: center;
              color: #333333;
              line-height: 20px;
              height: 20px;
              vertical-align: top;
              margin-left: 6px;
            }
          }

          .card-bind-tag-item-activate {
            background: #fff;
            position: relative;

            &:nth-child(1)::after {
              content: '';
              position: absolute;
              right: 0;
              bottom: 0;
              width: 8px;
              height: 8px;
              background-color: #fff;
              border-radius: 0 0 8px 0;
            }

            &:nth-child(2)::before {
              content: '';
              left: -35px;
              background-color: #feeae8;
            }

            &:nth-child(2)::after {
              content: '';
              position: absolute;
              left: 0;
              bottom: 0;
              width: 12px;
              height: 12px;
              background-color: #fff;
              border-radius: 0 0 0 8px;
            }

            span {
              color: #f7591c;
            }
          }
        }

        .card-bind-input-div {
          margin: 30px 14px 0;
          border-bottom: 1px solid #EBEBEB;
        }

        .card-bind-tips {
          font-size: 12px;
          text-align: center;
          font-weight: 400;
          color: #6b6b6b;
          line-height: 17px;
          margin: 18px 20px;
        }
      }

      .card-bind-btn {
        height: 25px;
        background: linear-gradient(135deg, #fa770d, #f44d19);
        border-radius: 25px;
        width: calc(100% - 30px);
        text-align: center;
        padding: 10px 0;
        margin: 0 15px;

        span {
          display: inline-block;
          font-size: 18px;
          font-weight: 500;
          text-align: center;
          color: #ffffff;
          line-height: 25px;
        }
      }

      .card-bind-third-div {
        margin: 16px 12px 0;
        background: #ffffff;
        border-radius: 8px;
        padding: 12px 14px 20px 15px;
        div{
          &:nth-child(1) {
            font-size: 14px;
            font-weight: 500;
            color: #333333;
            line-height: 20px;
            display: flex;
            align-items: center;
          }
          &:nth-child(2) {
            margin-top: 10px;
            max-height: 21vh;
            overflow-y: auto;
            p {
              font-size: 12px;
              font-weight: 400;
              text-align: left;
              color: #3a3a3a;
              line-height: 17px;
            }
            &::-webkit-scrollbar {
              width: 4px;
            }
            &::-webkit-scrollbar-thumb { //滑块部分
              background: #eaeaea;
              border-radius: 2px;
            }
          }
        }
      }
    }


    .bm34 {
      bottom: 67px;
    }
  }
</style>